<template>
  <div
    :class="{
      'r-checkbox': true,
      'r-checkbox--disabled': this.disabled
    }"
  >
    <!-- input -->
    <input
      :class="{
        'r-checkbox--input': true,
        'r-checkbox--disabled': this.disabled
      }"
      type="checkbox"
      :id="`input-${_uid}`"
      v-on="listeners"
      :checked="value"
      :disabled="disabled"
    />

    <!-- checkbox -->
    <r-spinner
      v-if="loading"
      color="rgb(36, 105, 235)"
      size="14px"
      class="r-checkbox--loading"
    />
    <label
      :class="{
        'r-checkbox--label': true,
        'r-checkbox--rounded': this.rounded,
        'r-checkbox--disabled': this.disabled
      }"
      :for="`input-${_uid}`"
      v-else
    />

    <label
      :class="{
        'r-checkbox--text': $slots.default,
        'r-checkbox--disabled': this.disabled
      }"
    >
      <slot></slot>
    </label>
  </div>
</template>

<script>
/**
 * Define the checkbox component
 */
export default {
  // set the component name
  name: "r-checkbox",

  // external props
  props: {
    // if the checkbox should be rounded
    rounded: {
      type: Boolean,
      default: false
    },

    // if the checkbox is in loading state
    loading: {
      type: Boolean,
      default: false
    },

    // get value from output
    value: {
      type: Boolean,
      default: false
    },

    // color when checked
    color: {
      type: String,
      default: ""
    },

    // determine if disable
    disabled: {
      type: Boolean,
      default: false
    }
  },

  // calculated props
  computed: {
    /**
     * Returns modified listeners
     */
    listeners() {
      // get reference to vue instance
      const vm = this

      return {
        ...this.$listeners,

        input(event) {
          vm.$emit("input", event.target.checked)
        }
      }
    }
  }
}
</script>

<style lang="scss" scope>
$checkbox-size: 14px;

// main design chunk
.r-checkbox {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;

  &--disabled {
    cursor: not-allowed !important;
    color: grey;
  }

  &--input {
    cursor: pointer;
    visibility: hidden;

    &:checked + label {
      background: blue;
      border: 1px solid blue;
    }

    &:checked + label:after {
      opacity: 1;
    }
  }

  &--text {
    font-size: $checkbox-size;
    line-height: $checkbox-size;
    margin-left: 5px;
  }

  &--label {
    cursor: pointer;
    background: white;
    border: 1px solid #ccc;

    position: absolute;
    // left: 0;
    // top: 0;

    width: $checkbox-size;
    height: $checkbox-size;

    &:after {
      content: "";
    }
  }

  &--rounded {
    border-radius: 50%;
  }

  &--loading {
    width: auto !important;
    position: absolute;
  }
}
</style>
